import React, {forwardRef, useImperativeHandle, useRef} from 'react'
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next'
import {message} from 'antd';

import './index.less'
import './mobile.less'

import UserInfoForm from '@/components/UserInfoForm'
import SignupSuccess from '@/components/SignupSuccess'

import {getUsingClassName} from '@/common';
import {registerBusinessCustomer, baseUserCheckTaken} from '@/api/req-api'

// const str = 'olong-scm-001'
// const initialValues = {
//   name: `name ${str}`,
//   emailAddress: `${str}@mailinator.com`,
//   phoneNumber: `phoneNumber${str}`,
//   company: `company${str}`,
//   companyPhone: `companyPhone${str}`,
//   businessType: `businessType${str}`,
//   einNumber: `einNumber${str}`,
//   address: `address${str}`,
//   city: `city${str}`,
//   state: `state${str}`,
//   zipCode: `11354`,
// }

const defaultProps = {
  title: '',
  className: '',
  onRegisterAccountSuccess: () => {
  },
};

const getDateValue = value => {
  if (!value) {
    return value
  }
  return value.format ? value.format('YYYY-MM-DD') : value
}

const RegisterAccount = forwardRef(function (props, ref) {
  const options = Object.assign({}, defaultProps, props);

  const navigate = useNavigate()
  const {t} = useTranslation()
  
  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'register-account-mobile-container' : 'register-account-container'

  const signupSuccessRef = useRef(null);
  const userInfoFormRef = useRef(null);

  const resetFields = () => userInfoFormRef.current?.resetFields()
  const onFormFinish = async (values) => {
    const emailAddress = values.emailAddress
    const res = await baseUserCheckTaken({email: emailAddress})
    if (res.data.isTaken) {
      return message.error('User with this email already exists')
    }
    const params = {
      full_name: values.name,
      email: emailAddress,
      phone_number: values.phoneNumber,
      business_name: values.company,
      business_phone: values.companyPhone,
      business_type: Array.isArray(values.businessType) ? values.businessType.join(', ') : values.businessType,
      ein: values.einNumber,
      street: values.address,
      city: values.city,
      state: values.state,
      zipcode: values.zipCode,
      fax: values.fax,
      business_established_date: getDateValue(values.business_established_date),
      num_employees: values.num_employees,
      state_tax_id: values.state_tax_id,
      resale_no: values.resaleNumber,
      president: values.president,
      purchasing_manager: values.purchasing_manager,
      ap_manager: values.ap_manager,
      bank_name: values.bank_name,
      bank_branch: values.bank_branch,
      bank_address: values.bank_address,
      bank_account_no: values.bank_account_no,
      bank_tel: values.bank_tel,
      bank_contact_person: values.bank_contact_person,
      trade_ref_1_company_name: values.trade_ref_1_company_name,
      trade_ref_1_address: values.trade_ref_1_address,
      trade_ref_1_tel: values.trade_ref_1_tel,
      trade_ref_1_fax: values.trade_ref_1_fax,
      trade_ref_2_company_name: values.trade_ref_2_company_name,
      trade_ref_2_address: values.trade_ref_2_address,
      trade_ref_2_tel: values.trade_ref_2_tel,
      trade_ref_2_fax: values.trade_ref_2_fax,
      trade_ref_3_company_name: values.trade_ref_3_company_name,
      trade_ref_3_address: values.trade_ref_3_address,
      trade_ref_3_tel: values.trade_ref_3_tel,
      trade_ref_3_fax: values.trade_ref_3_fax,
      country: 'US'
    }
    registerBusinessCustomer(params)
      .then(() => {
        resetFields()
        signupSuccessRef.current?.showModal()
        options.onRegisterAccountSuccess(values)
      })
  }
  const handleRegisterAccountClick = () => {
    userInfoFormRef.current?.submit()
  }
  const handleFormFinishFailed = () => {
    message.error(t('Please complete all required fields before submitting.'))
  }

  const handleTermsOfServiceClick = () => {
    navigate('/termsOfService')
  }
  const handlePrivacyPolicyClick = () => {
    navigate('/privacyPolicy')
  }

  const className = getUsingClassName(
    [rootClassName],
    [options.className]
  )
  
  useImperativeHandle(ref, () => ({
    resetFields,
  }))

  return (
    <div className={className}>
      <div className={'register-account-title'}>
        {t('Account Application')}
      </div>
      <div className={'register-account-subtitle'}>
        {t('Start business with Chun Yuen Trading Co.')}
      </div>
      <UserInfoForm
        ref={userInfoFormRef}
        isAccountApplication={true}
        isShowBaseInfo={true}
        isShowCompanyInfo={true}
        isShowAddressInfo={true}
        isShowPassword={false}
        isRequiredBusinessType={true}
        onFormFinish={onFormFinish}
        onFormFinishFailed={handleFormFinishFailed}
      />
      <div className={'register-account-tip-container'}>
        <span>{t('By continuing, you agree to')} Chun Yuen Trading Co.</span>
        <span className={'register-account-tip-link'} onClick={handleTermsOfServiceClick}>
          {t('Terms of Service')}
        </span>
        <span> {t('and')} </span>
        <span className={'register-account-tip-link'} onClick={handlePrivacyPolicyClick}>
          {t('Privacy Policy')}
        </span>
      </div>
      <div className={'register-account-btn'} onClick={handleRegisterAccountClick}>
        {t('Submit Application')}
      </div>
      <SignupSuccess ref={signupSuccessRef} />
    </div>
  )
})

export default RegisterAccount
